import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

import {
    NgForm,
    FormGroup,
    FormControl,
    FormArray,
    Validators,
    ValidatorFn,
    AsyncValidatorFn
} from '@angular/forms';
import { MessageComponent, BaseComponent } from '../common/common-components';
import { BankAccountService } from "./bank-account-service";
import { DictionaryService } from "../services/dictionary-service";
import { MessageService } from "../services/message-service";
import { ModalService } from "../services/modal-service";
import { ActivatedRoute } from '@angular/router';
import { TextMaskModule } from 'angular2-text-mask';

let _: any = require("lodash");
declare var ga: any;

@Component({
    selector: 'dk-bank-account-edit',
    inputs: ['id'],
    template: require('./bank-account-edit.html'),
    entryComponents: [],
    providers: [BankAccountService, DictionaryService]
})

export class BankAccountEditComponent extends BaseComponent implements OnInit {
    public id: number;
    public errorMessageId: string;
    public showBankDetails: boolean;
    public viewNumber = 1;
    @Output() cancel = new EventEmitter();
    @Output() saved = new EventEmitter();

    public owners: any[];
    public currencies: any[];
    public countries: any[];
    public mask: any;
    public pipe: any;
    public polishMask = [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ',
        /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
    public foreignMask = function (value) {
        return value.split('').map(() => /./);
    };

    form: FormGroup = new FormGroup({
        OwnerID: new FormControl(null, Validators.required),
        CurrencyID: new FormControl(null, Validators.required),
        BankCountryID: new FormControl(null, Validators.required),
        IBAN: new FormControl('', Validators.required),
        BankName: new FormControl(''),
        Swift: new FormControl(''),
        SmsCode: new FormControl('')
    });

    constructor(private bankAccountService: BankAccountService,
        private dictionaryService: DictionaryService,
        private messageService: MessageService,
        private modalService: ModalService,
        private route: ActivatedRoute) {
        super();
        this.showBankDetails = false;
    }

    get selectedCountryPrefix(): string {
        if (this.countries) {
            let item = _.find(this.countries, item => item.Id == this.form.controls['BankCountryID'].value);
            if (item) {
                return item.Prefix;
            }

            return null;
        }
    }

    get selectedOwnerName(): string {
        if (this.owners) {
            let item = _.find(this.owners, item => item.Id == this.form.controls['OwnerID'].value);
            if (item) {
                return item.Name;
            }

            return null;
        }
    }

    get selectedCurrencyName(): string {
        if (this.currencies) {
            let item = _.find(this.currencies, item => item.Id == this.form.controls['CurrencyID'].value);
            if (item) {
                return item.Name;
            }

            return null;
        }
    }

    get selectedCountryName(): string {
        if (this.countries) {
            let item = _.find(this.countries, item => item.Id == this.form.controls['BankCountryID'].value);
            if (item) {
                return item.Name;
            }

            return null;
        }
    }

    get bankName(): string {
        return this.form.controls['BankName'].value;
    }

    get swift(): string {
        return this.form.controls['Swift'].value;
    }

    get ibanControl(): FormControl {
        return this.form.controls['IBAN'] as FormControl;
    }

    next() {
        this.touchFormGroup(this.form);
        if (this.form.valid) {
            this.errorMessageId = null;
            this.bankAccountService.isSwiftVisible(this.form.controls['BankCountryID'].value, this.form.controls['IBAN'].value).subscribe(isSwiftVisible => {
                if (isSwiftVisible) {
                    this.loadBankNameAndSwift(this.form.controls['BankCountryID'].value, this.form.controls['IBAN'].value);
                    this.untouchFormGroup(this.form);
                    this.form.controls['BankName'].setValidators(Validators.required);
                    this.form.controls['Swift'].setValidators(Validators.required);
                    this.viewNumber = 2;
                }
                else {
                    this.errorMessageId = "12";
                }
            });
        }
    }

    back() {
        this.viewNumber = 1;
        this.form.controls['BankName'].setValidators(null);
        this.form.controls['BankName'].updateValueAndValidity();
        this.form.controls['Swift'].setValidators(null);
        this.form.controls['Swift'].updateValueAndValidity();
        this.errorMessageId = null;
    }

    submit() {
        this.touchFormGroup(this.form);

        if (this.form.valid) {
            var account = this.form.value;
            account.BankAccountID = this.id;
            this.errorMessageId = null;
            this.bankAccountService.isSmsNeededForNewAccount(account).subscribe(isSmsNeeded => {
                if (isSmsNeeded) {
                    if (this.showBankDetails == true) {
                        this.bankAccountService.isSwiftCorrect(account).subscribe(isSwiftCorrect => {
                            if (isSwiftCorrect) {
                                this.modalService.sendSmsCode();
                                this.form.controls['SmsCode'].setValue('');
                                this.viewNumber = 3;
                            }
                            else {
                                this.errorMessageId = "57";
                            }
                        });
                    }
                    else {
                        this.modalService.sendSmsCode();
                        this.form.controls['SmsCode'].setValue('');
                        this.viewNumber = 3;
                    }
                }
                else {
                    this.bankAccountService.edit(account).subscribe(() => {
                        this.messageService.success('BankAccounts.DataSavedSuccessfully');
                        this.saved.emit();
                        ga('send', 'event', 'konta', 'dodanie-rachunku-bankowego', this.selectedCurrencyName, null, account);
                    }, (error) => {
                        this.errorMessageId = error.messageId;
                    });
                }
            });
        }
    }

    confirmWithSms() {
        this.touchFormGroup(this.form);
        if (this.form.valid) {
            var account = this.form.value;
            account.BankAccountID = this.id;
            this.errorMessageId = null;
            let code = this.form.controls['SmsCode'].value;
            this.bankAccountService.edit(account, code).subscribe(() => {
                this.messageService.success('BankAccounts.DataSavedSuccessfully');
                this.saved.emit();
                ga('send', 'event', 'konta', 'dodanie-rachunku-bankowego', this.selectedCurrencyName, null, account);
            }, (error) => {
                this.errorMessageId = error.messageId;
                this.viewNumber = 2;
            });
        }
    }

    public cancelEdit() {
        this.cancel.emit();
    }

    public ngOnInit() {
        this.form.controls['BankCountryID'].setValue(167);
        this.mask = this.polishMask;

        this.dictionaryService.owners().subscribe(owners => {
            this.owners = owners;

            let ownerId = this.route.snapshot.params['ownerId'];

            if (this.id == null) {
                if (ownerId) {
                    this.form.controls['OwnerID'].setValue(ownerId);
                } else {
                    if (owners[0]) {
                        this.form.controls['OwnerID'].setValue(owners[0].Id);
                    }
                }
            }
        });

        this.dictionaryService.currencies().subscribe(currencies => {
            let currencyId = this.route.snapshot.params['currencyId'];

            if (this.id == null) {
                if (currencyId) {
                    this.form.controls['CurrencyID'].setValue(currencyId);
                }
            }

            this.currencies = currencies;
        });

        this.dictionaryService.countries().subscribe(countries => {
            this.countries = countries;
        });

        this.form.controls['BankCountryID'].valueChanges.subscribe(() => {
            if (this.form.controls['BankCountryID'].value == '1') {
                this.mask = this.polishMask;
                this.pipe = false;
            }
            else {
                this.mask = this.foreignMask;
                this.pipe = function (value) {
                    return value.replace(/\s/g, '');
                }
            }
        });
    }

    protected loadBankNameAndSwift(bankCountryId, iban) {
        this.bankAccountService.getBankName(bankCountryId, iban).subscribe(value => {
            this.showBankDetails = value == null;
            this.form.controls['BankName'].setValue(value);
        });

        this.bankAccountService.getSwift(bankCountryId, iban).subscribe(value => {
            this.form.controls['Swift'].setValue(value);
        });
    }
}
